module.exports = __webpack_public_path__ + "img/visa.04bcbc1.png";